/**
 * AgingCategory
 */
export type AgingCategory = 'V_S_O_P' | 'V_S' | 'X_O' | 'HORSE_D_AGE' | 'EXTRA';

export const AgingCategory = {
  VSOP: 'V_S_O_P' as AgingCategory,
  VS: 'V_S' as AgingCategory,
  XO: 'X_O' as AgingCategory,
  HorseDAge: 'HORSE_D_AGE' as AgingCategory,
  Extra: 'EXTRA' as AgingCategory,
};
